// extracted by mini-css-extract-plugin
export default {"gift_returns_input":"_1Ot_","gift_box_title":"_2VLP","gift_box_holder":"_13y2","gift_box_msg":"MnRt"};